const HISTORY_POSITION_KEY = '__rootedHistoryPosition'
const HISTORY_RUNTIME_KEY = '__rootedSameDocumentHistoryRuntime'

const stateWithPosition = (state, position) => ({ ...(state || {}), [HISTORY_POSITION_KEY]: position })

const installHistoryRuntime = () => {
  if (typeof window === 'undefined') return null
  if (window[HISTORY_RUNTIME_KEY]) return window[HISTORY_RUNTIME_KEY]

  const nativePushState = window.history.pushState.bind(window.history)
  const nativeReplaceState = window.history.replaceState.bind(window.history)
  const initialPosition = Number.isInteger(window.history.state?.[HISTORY_POSITION_KEY])
    ? window.history.state[HISTORY_POSITION_KEY]
    : 0
  const runtime = { guards: new Set(), position: initialPosition }
  window[HISTORY_RUNTIME_KEY] = runtime

  nativeReplaceState(stateWithPosition(window.history.state, runtime.position), '', window.location.href)
  window.history.pushState = (state, title, url) => {
    runtime.position += 1
    return nativePushState(stateWithPosition(state, runtime.position), title, url)
  }
  window.history.replaceState = (state, title, url) => (
    nativeReplaceState(stateWithPosition(state, runtime.position), title, url)
  )

  window.addEventListener('popstate', event => {
    const destinationPosition = event.state?.[HISTORY_POSITION_KEY]
    const previousPosition = runtime.position
    const tracked = Number.isInteger(destinationPosition)
    if (tracked) runtime.position = destinationPosition
    const delta = tracked ? destinationPosition - previousPosition : null
    const traversal = {
      delta,
      direction: delta === null || delta === 0 ? null : (delta < 0 ? 'back' : 'forward'),
      position: tracked ? destinationPosition : null,
    }

    for (const guard of runtime.guards) {
      if (!guard(event, traversal)) continue

      event.stopImmediatePropagation()
      break
    }
  }, true)

  return runtime
}

const historyRuntime = installHistoryRuntime()

export const currentSameDocumentHistoryPosition = () => historyRuntime?.position ?? null

export const registerSameDocumentHistoryGuard = guard => {
  historyRuntime?.guards.add(guard)
  return () => historyRuntime?.guards.delete(guard)
}
